import { Link, Image, Box, Text, Flex, useClipboard, Tooltip, useToast } from '@chakra-ui/react';

import CopyIcon from 'public/icons/copy_icon.svg';
import FacebookIcon from 'public/icons/facebook_icon.svg';
import TwitterIcon from 'public/icons/twitter_icon.svg';

interface Props {
  title: string;
  url: string;
}

export const Share: React.FC<Props> = ({ title, url }) => {
  const { onCopy } = useClipboard(url);
  const toast = useToast();

  const handleCopyToClipboard = () => {
    onCopy();
    toast({
      position: 'bottom',
      duration: 3000,
      // eslint-disable-next-line
      render: () => (
        <Box color="white" mb="32px" p="21.5px 32px" bg="rgba(15, 20, 36, 0.87)" borderRadius={8}>
          URLをコピーしました
        </Box>
      ),
    });
  };

  return (
    <Flex display={{ base: 'none', md: 'flex' }}>
      <Text textStyle="body2">記事をシェア</Text>
      <Box marginLeft="17px">
        <Tooltip label="URLをコピー" hasArrow placement="top">
          <Box as="button" onClick={handleCopyToClipboard}>
            <Image src={CopyIcon} alt="クリップボードにコピー" />
          </Box>
        </Tooltip>
      </Box>
      <Box marginLeft="26px">
        <Tooltip label="Facebookでシェア" hasArrow placement="top">
          <Link
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            target="_blank"
            rel="nofollow noreferrer"
          >
            <Image src={FacebookIcon} alt="Facebookでシェア" />
          </Link>
        </Tooltip>
      </Box>
      <Box marginLeft="26px">
        <Tooltip label="Twitterでシェア" hasArrow placement="top">
          <Link
            href={`https://twitter.com/intent/tweet?text=${title}&url=${url}&hashtags=shizai`}
            target="_blank"
            rel="nofollow noreferrer"
          >
            <Image src={TwitterIcon} alt="TwitterでTweet" />
          </Link>
        </Tooltip>
      </Box>
    </Flex>
  );
};
